<template>
  <div class="space-y-4">
    <p class="text-md font-semibold text-gray-800 dark:text-gray-100">Choose location </p>
    <UDivider class="border-gray-300 dark:border-gray-600" />
    <h5 v-if="list.length === 0">No Seller Near You</h5>
    <div 
      class="overflow-y-auto max-h-[30rem] space-y-4" 
    >
    <div 
      v-for="(item, index) in visibleList" 
      :key="index" 
      class="flex items-center justify-between p-2 border rounded-lg shadow-sm cursor-pointer border-gray-200"
      :class="index === 0 ? 'bg-primeval-50 border-1 border-primeval-700 pointer-events-none' : 'bg-gray-50'"
      @click="redirectLocation(item.ukid)"
    >
      <div class="flex flex-col">
        <p class="text-sm text-gray-500 dark:text-gray-400" v-if="index === 0">
          Your selection
        </p>
        <p class="text-md font-medium text-gray-900 dark:text-gray-100 truncate max-w-[300px]">{{ item.locality.split(',').join(', ') }}</p>
        <div class="inline-flex gap-2">
          <p class="text-md text-gray-500 dark:text-gray-400">{{ item.distance }}</p>
          <p>|</p>
          <UBadge label="Open" class="bg-green-700 text-white" size="xs" v-if="item.isOpened"></UBadge>
          <UBadge label="Closed" color="black" size="sm" v-else></UBadge>
        </div>
      </div>
    </div>
      <div v-if="hasMore" class="text-center mt-5">
      <button 
        class="text-orange-500 text-md font-bold cursor-pointer" 
        @click="showMore"
      >
        See more locations
      </button>
    </div>
    </div>
  </div>
</template>

<script setup>
const props = defineProps(['provider', 'data']);
const list = props.data.sort((a, b) => b.is_default - a.is_default);
const batchSize = 10; 
const currentBatch = ref(1);

const visibleList = computed(() => list.slice(0, currentBatch.value * (currentBatch.value === 1 ? batchSize : 100)));
const hasMore = computed(() => currentBatch.value * batchSize < list.length);

const showMore = () => {
  currentBatch.value += 1;
};
const isOpened = (opened) => {
  return opened ? 'Open' : 'Closed';
};

const redirectLocation = (ukid) => {
  window.location.replace(`/providers/${ukid}`);
}

console.log("data", list);
</script>
